import Container from "../components/Container";
import {Button, Divider} from "antd";
import React from "react";
import {Link, useSearchParams} from "react-router-dom";
import {MdCheckCircleOutline,MdClose} from "react-icons/md";
const BillPayment = () => {

    const [searchParams, setSearchParams] = useSearchParams();

    const SuccessCard=()=>{

        return <>
            <div className="flex justify-center">
                <MdCheckCircleOutline size={50} className="text-green-400"/>
            </div>
            <div className="item flex mb-4 mt-3 justify-between items-center"><strong className="text-sm whitespace-nowrap px-2">وضعیت
                عملیات</strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2  text-green-400 text-sm whitespace-nowrap ">موفق</span></div>
            <div className="item flex mb-4  justify-between items-center">
                <strong className="text-sm whitespace-nowrap px-2">شماره رهگیری</strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2 text-sm whitespace-nowrap ">{searchParams.get('TraceNumber')}</span></div>
            <div className="item flex mb-4  justify-between items-center">
                <strong className="text-sm whitespace-nowrap px-2">شناسه قبض</strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2 text-sm whitespace-nowrap ">{searchParams.get('BillId')}</span></div>
            <div className="item flex mb-4  justify-between items-center">
                <strong className="text-sm whitespace-nowrap px-2">شناسه پرداخت </strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2 text-sm whitespace-nowrap ">{searchParams.get('PayId')}</span></div>
            <div className="item flex mb-4  justify-between items-center">
                <strong className="text-sm whitespace-nowrap px-2">شماره مرجع</strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2 text-sm whitespace-nowrap ">{searchParams.get('RRN')}</span></div>
            <div className="item flex mb-4  justify-between items-center">
                <strong className="text-sm whitespace-nowrap px-2">مبلغ به ریال </strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2 text-sm whitespace-nowrap ">{searchParams.get('Amount')}</span></div>
            <div className="item flex mb-4  justify-between items-center">
                <strong className="text-sm whitespace-nowrap px-2">زمان تراکنش </strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2 text-sm whitespace-nowrap ">{searchParams.get('Date')}</span></div>
            <div className="item flex mb-4  justify-between items-center">
                <strong className="text-sm whitespace-nowrap px-2">شماره سفارش</strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2 text-sm whitespace-nowrap ">{searchParams.get('OrderId')}</span></div>

        </>
    }
    const FailedCard=()=>{

        return <>
            <div className="flex justify-center">
                <MdClose size={50} className="text-red-400"/>
            </div>
            <div className="item flex mb-4 mt-3 justify-between items-center"><strong className="text-sm whitespace-nowrap px-2">وضعیت
                عملیات</strong>
                <div className="w-full px-2 mt-1 border-t"/>
                <span className="px-2 text-red-500 text-sm whitespace-nowrap ">نا موفق</span></div>

            <p className="text-sm ">{searchParams.get('Message')}</p>
        </>
    }


    return <Container>
        <div className="w-full mx-auto md:w-9/12 lg:w-8/12 xl:w-7/12">
            <div className="p-5 rounded-xl bg-white">
                <Divider><h3 className="font-bold ">رسید تراکنش</h3></Divider>
                {searchParams.get('Status')==='-1' ? <FailedCard/> : <SuccessCard/>}
                <Divider/>
                <div className=" flex  justify-center">
                    <Link to={'/panel'}><Button type="primary">بازگشت به پنل</Button></Link>
                </div>
            </div>
        </div>


    </Container>
}
export default BillPayment;